import React, { createContext, useCallback, useContext, useEffect, useMemo } from "react";

/*
    Portfolio Bailador usa una identidad dark fija.
    Se conserva el contrato del contexto para no romper componentes del Core,
    pero no existe una preferencia alternable de tema.
*/
const ThemeContext = createContext();
const DARK_META = { code: "dark", label: "Oscuro" };

const APPLY_DARK = () => {
    if (typeof document === "undefined") return "dark";
    const root = document.documentElement;
    root.dataset.theme = "dark";
    root.setAttribute("data-bs-theme", "dark");
    root.style.colorScheme = "dark";
    return "dark";
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context) return context;

    return {
        useDataTheme: {
            isLoading: false,
            currentTheme: "dark",
            resolvedTheme: "dark",
            availableThemes: ["dark"],
            availableThemesMeta: [DARK_META],
        },
        call_isDark: () => true,
        call_getThemeMeta: () => DARK_META,
        call_setTheme: APPLY_DARK,
        call_toggleTheme: APPLY_DARK,
        call_refreshTheme: APPLY_DARK,
    };
};

export const ThemeProvider = ({ children }) => {
    useEffect(() => { APPLY_DARK(); }, []);

    const call_isDark = useCallback(() => true, []);
    const call_getThemeMeta = useCallback(() => DARK_META, []);
    const call_setTheme = useCallback(() => APPLY_DARK(), []);
    const call_toggleTheme = useCallback(() => APPLY_DARK(), []);
    const call_refreshTheme = useCallback(() => APPLY_DARK(), []);

    const value = useMemo(() => ({
        useDataTheme: {
            isLoading: false,
            currentTheme: "dark",
            resolvedTheme: "dark",
            availableThemes: ["dark"],
            availableThemesMeta: [DARK_META],
        },
        call_isDark,
        call_getThemeMeta,
        call_setTheme,
        call_toggleTheme,
        call_refreshTheme,
    }), [call_getThemeMeta, call_isDark, call_refreshTheme, call_setTheme, call_toggleTheme]);

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
